import subYears from 'date-fns/subYears'

export const MIN_YEARS_OLD = 18
export const MAX_YEARS_OLD = 100

export const BIRTHDATE_RANGE_START = subYears(new Date(), MIN_YEARS_OLD)
export const BIRTHDATE_RANGE_END = subYears(new Date(), MAX_YEARS_OLD)

export const MAX_AMOUNT = 999999999
export const MIN_AMOUNT = 1

export enum ValidationLength {
  ADDRESS_MIN = 2,
  ADDRESS_MAX = 255,
  APT_MAX = 5,
  DRIVER_LINCENSE_MIN = 7,
  EMAIL_SHORT = 6,
  EMAIL_MAX = 60,
  EMAIL_SHORT_MAX = 50,
  EMPLOYEE_NAME_MAX = 30,
  JOB_TITLE_MAX = 26,
  INCOME_MIN = 1,
  INCOME_MAX = 999998,
  NAME_MIN = 2,
  CITY_MAX = 70,
  FIRST_NAME_MAX = 15,
  LAST_NAME_MAX = 25,
  PHONE_NUMBER = 10,
  SSN = 9,
  ZIP_CODE = 5,
  PASSWORD = 6,
  RENT_MAX = 6,
  INCOME_NUM_MAX = 7,
  DRIVER_LICENCE_MAX = 15,
  DRIVER_LICENCE_MIN = 7,
  VIN_MAX = 17,
  VEHICLE_INFO_MAX = 100
}

export enum Errors {
  Empty = 'Field is required',
  NotSymbols = 'Should not contain symbols',
  LongName = 'Name seems to be too long',
  Email = 'Invalid email',
  LongEmail = 'Email seems to be too long',
  ShortEmail = 'Email seems to be too short',
  InvalidDate = 'Invalid date',
  OnlyLatin = 'Should contain only latin characters',
  InvalidAddress = 'Address should have state, city, address and zip code',
  InvalidCondition = 'Please select one of the options',
  LongFirstName = 'Should contain at most 15 characters',
  LongLastName = 'Should contain at most 25 characters',
}

export const ErrorsMsg = {
  minAmount: `Cannot be less than ${MIN_AMOUNT}`,
  maxAmount: `Cannot be bigger than ${MAX_AMOUNT}`,
  minName: `Should contain at least ${ValidationLength.NAME_MIN} letters`,
  phoneNumber: `Should contain ${ValidationLength.PHONE_NUMBER} numbers`,
  birthdayMax: `You need to be ${MIN_YEARS_OLD} years or older`,
  birthdayMin: `You need to be ${MAX_YEARS_OLD} years or younger`
}
